const r2 = (n) => Math.round((n + Number.EPSILON) * 100) / 100;

export function computeTotals(cart, discount = 0) {
  let gross = 0;
  let tax = 0;
  let count = 0;
  cart.forEach((l) => {
    const lt = l.price * l.qty;
    const tx = (lt * l.tax_rate) / (100 + l.tax_rate);
    gross += lt;
    tax += tx;
    count += l.qty;
  });
  const grossR = r2(gross);
  const taxR = r2(tax);
  return {
    gross: grossR,
    tax: taxR,
    net: r2(grossR - taxR),
    discount: r2(discount),
    balance: r2(grossR - discount),
    count,
  };
}

export function money(n) {
  return Number(n || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}
